import React from 'react';
import './about.css';
import { FaCamera, FaBlogger, FaPlane, FaVideo } from 'react-icons/fa'; // Import icons from react-icons/fa
import photographerImage from '../../assets/img/about/about-1.jpeg';
import profilePic from '../../assets/img/about/profile.jpg';
import verifiedBadge from '../../assets/img/about/verified.jpeg'; // Import the custom verified badge image

const About = () => {
  return (
    <div className="about-container">
      <div className="image-container">
        <img src={photographerImage} alt="Photographer" className="photographer-image" />
      </div>
      <div className="content-container">
        <div className="profile-header">
          <img src={profilePic} alt="Profile" className="profile-pic" />
          <h2>Shanzae Zia <img src={verifiedBadge} alt="Verified Badge" className="verified-icon" /></h2> {/* Add custom verified badge */}
        </div>
        <div class="user-info">
  <p>
    <strong>شانزۓ ضیاء ارمغان</strong> <br />
  </p>
</div>

<div class="user-stats-container">
  <p>
    <span class="user-stats">Posts: 999+ </span>
    <span class="user-stats"> Followers: 62k </span>
    <span class="user-stats"> Following: 167</span>
  </p>
</div>
        <p>
          <strong>Photographer</strong> <br />
          <span className='words' style={{ color: '#ffff' }}>Marketing Head 💻 | Wedding Photographer📸 | Corporate 🎥 | Blogger | Traveler🌎</span>
        </p>
        <p>
          As a passionate photographer, I specialize in capturing precious moments, from weddings to cinematic photography. With a love for blogging and traveling, I constantly seek inspiration from the world around me, creating stunning visual stories through my lens. My goal is to provide unique and memorable experiences through my photography and share my adventures with the world.
        </p>
        <div className="additional-info">
          <h3>Expertise</h3>
          <ul>
            <li><FaCamera className="expertise-icon" /> Wedding Photography</li>
            <li><FaBlogger className="expertise-icon" /> Blogging</li>
            <li><FaPlane className="expertise-icon" /> Travel Photography</li>
            <li><FaVideo className="expertise-icon" /> Cinematic Photography</li>
            <li><FaCamera className="expertise-icon" /> Portrait Photography</li>
            <li><FaBlogger className="expertise-icon" /> Content Creation</li>
            <li><FaPlane className="expertise-icon" /> Aerial Photography</li>
            <li><FaVideo className="expertise-icon" /> Documentary Photography</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default About;